import {
  deleteKPIGoal as apiDeleteKPIGoal,
  getKPIGoals,
  getKPIOptions,
  KPIGoal,
  KPIOption,
} from '@/api/kpi'
import { useEffect, useMemo, useState } from 'react'

interface Selectable {
  id: string
  name: string
}

type ListSelections = {
  branch?: Selectable
  year?: Selectable
  quarter?: Selectable
}

export default function useKpiGoals(listSelections: ListSelections) {
  const [options, setOptions] = useState<(KPIOption & Selectable)[]>([])
  const [oldKPIGoals, setOldKPIGoals] = useState<KPIGoal[]>([])
  const [loading, setLoading] = useState(false)

  const fetchKPIGoals = useMemo(() => {
    return async () => {
      setLoading(true)
      const goals = await getKPIGoals(
        listSelections.branch?.id,
        listSelections.quarter?.id,
        listSelections.year?.id
      )
      setOldKPIGoals(goals)
      setLoading(false)
    }
  }, [])

  const fetchKPIOptions = useMemo(() => {
    return async () => {
      setLoading(true)
      const kpiOpts = await getKPIOptions()
      setOptions(
        kpiOpts.map((opt) => ({
          ...opt,
          id: opt.id.toString(),
          name: opt.title,
        }))
      )
      setLoading(false)
    }
  }, [])

  const deleteKPIGoal = useMemo(() => {
    return async (id: string) => {
      setLoading(true)
      try {
        await apiDeleteKPIGoal(id)
        setOldKPIGoals((prev) => prev.filter((kpi) => kpi.id.toString() !== id))
      } catch (error) {
        alert('Failed to delete KPI. Please try again.')
      } finally {
        setLoading(false)
      }
    }
  }, [])

  useEffect(() => {
    Promise.all([fetchKPIGoals(), fetchKPIOptions()])
  }, [])

  return { options, oldKPIGoals, deleteKPIGoal, loading, fetchKPIGoals }
}
